export default __webpack_public_path__ + "static/flexible-payment.url-c093924d7a4705cc810172526525910b.svg";